import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { collectionsContext } from "../context/collectionsContext";

const url = new URL(window.location.href);
const getCategory = url.searchParams.get('category');
const getImg = url.searchParams.get('img');
const getPrice = url.searchParams.get('imgPrice');
const getElementId = url.searchParams.get('itemId');

export const useTextureData = (elementId: number) => {
    const { collectionsData } = useContext(collectionsContext);
    const curElementId = getElementId ? getElementId : elementId;
    // const [isImgChanged, setIsImgChanged] = useState(false);
    const domContainer = document.querySelector('#constructor_app'),
        ajaxMode = window.location.hostname === 'localhost' || domContainer?.getAttribute('data-set-ajax-mode') === 'true'
    ;

    const elementID = domContainer?.getAttribute('data-element-id') ? domContainer?.getAttribute('data-element-id') : curElementId;

    const [textureData, setTextureData] = useState({
        img: '',
        price: 0,
        catalog: '',
        items: [{ id: '', name: '', img: '', price: 0 }],
        remove_background: [0],
        fullData: {},
    });

    // const [elementId, setElementId] = useState(collectionsData?.elementId);
    //
    // useEffect(() => {
    //     // console.log('useEffect');
    //     // console.log(collectionsData.elementId)
    //     // setElementId(collectionsData.elementId);
    //     //
    //     //
    //     //
    //     //
    //     // setIsImgChanged(true);
    //
    //
    //     // const handleClick = (event: MouseEvent) => {
    //     //     console.log('click')
    //     //     if((event.target as Element).classList.contains("js-constructor-item-wrapper")) {
    //     //         console.log('click222')
    //     //         const elementId = (event.target as Element).getAttribute('data-element-id');
    //     //         if(elementId) {
    //     //             setElementId(1008);
    //     //             setIsImgChanged(true);
    //     //         }
    //     //     }
    //     //
    //     // };
    //
    //
    //     // document.addEventListener('click', handleClick);
    //     //
    //     // return () => {
    //     //     document.removeEventListener('click', handleClick);
    //     // };
    // }, []);

    useEffect(() => {
        let isSubscribed = true;
        if(isSubscribed) {
            const fetchData = async () => {
                async function getTextureData(elementId: number) {
                    return await axios.get(`https://fresq.ru/app/ajax/?type=image&element_id=${elementId}`);
                }
                await getTextureData(elementID as number).then(response => {
                    const responseImgData = response.data;
                    // const curSectionData = JSON.parse(localStorage!.getItem(`sectionData_${collectionsData.sectionId}`)!);
                    const ImgData = {
                        img: getImg ? getImg : responseImgData ? responseImgData.items[0]?.img : '',
                        // img: getImg && !isImgChanged
                        // img: getImg
                        //     ? getImg
                        //     : curSectionData && curSectionData.texture && responseImgData
                        //         ? responseImgData.items.find( (item: { id: number; }) => item.id === curSectionData.texture).img
                        //         : responseImgData.items[0]?.img,
                        price: getPrice ? parseInt(getPrice) : responseImgData ? responseImgData.items[0]?.price : 0,
                        items: responseImgData ? responseImgData.items : {},
                        catalog: responseImgData ? responseImgData.catalog : {},
                        remove_background: responseImgData ? responseImgData.remove_background : {},
                        fullData: {},
                    };

                    setTextureData(ImgData);
                });
            }

            fetchData()
                .catch(console.error);
        }

        // if(ajaxMode) {
        //     getTextureData(elementID as number).then(response => {
        //         const responseImgData = response.data;
        //         const ImgData = {
        //             img: getImg && !isImgChanged ? getImg : responseImgData ? responseImgData.items[0]?.img : '',
        //             price: getPrice ? parseInt(getPrice) : responseImgData ? responseImgData.items[0]?.price : 0,
        //             items: responseImgData ? responseImgData.items : {},
        //             catalog: responseImgData ? responseImgData.catalog : {},
        //             remove_background: responseImgData ? responseImgData.remove_background : {},
        //             fullData: {},
        //         };
        //
        //         setTextureData(ImgData);
        //     });
        // } else {
        //     const JSONImgData = domContainer?.getAttribute('data-imgData');
        //     const ImgData = {
        //         img: getImg ? getImg : JSONImgData ? 'https://fresq.ru/'+JSON.parse(JSONImgData)['items'][0].img : '',
        //         price: getPrice ? parseInt(getPrice) : JSONImgData ? JSON.parse(JSONImgData)['items'][0].price : 0,
        //         items: JSONImgData ? JSON.parse(JSONImgData)['items'] : {},
        //         catalog: JSONImgData ? JSON.parse(JSONImgData)['items'][0].catalog : {},
        //         remove_background: JSONImgData ? JSON.parse(JSONImgData).remove_background : [],
        //         fullData: {},
        //     };
        //     setTextureData(ImgData);
        // }

        return () => {
            isSubscribed = false;
        };
    }, [elementId]);

    return [textureData];
};

